import classNames from 'classnames';
import React, { memo } from 'react';

import { AssetDto } from 'common/api/autogenerated/trading-gateway';

import { SvgIconUrl } from 'common/components';

import svgIcons from 'common/svgIcons';

import './index.css';

type AssetIconsProps = {
  assetCardClassName?: string;
  className?: string;
} & Pick<AssetDto, 'name'>;

const AssetIcons: React.FC<React.PropsWithChildren<AssetIconsProps>> = ({ name, assetCardClassName, className }) => {
  if (!name) return null;

  const [base, quoted] = name.split('/');
  const iconsClasses = classNames({
    'asset-icons': true,
    [`${className}`]: className,
    ...(assetCardClassName ? { [assetCardClassName]: assetCardClassName } : {}),
  });
  return (
    <div className={iconsClasses}>
      <SvgIconUrl className='asset-icons__icon' symbol={svgIcons.Asset(base) || svgIcons.AssetDefault()} />
      <SvgIconUrl className='asset-icons__icon' symbol={svgIcons.Asset(quoted) || svgIcons.AssetDefault()} />
    </div>
  );
};

export default memo(AssetIcons);
